<template>
  <div>
    <v-row dense class="mb-3">
      <v-col v-for="item in deliveryStatusOptions" :key="`i_${item.value}`">
        <v-btn
          color="primary"
          block
          :outlined="status != item.value"
          @click="changeStatus(item.value)"
        >
          {{ item.text }}
          <span class="orange--text" v-if="!!item.count || item.count == 0">
            ({{ item.count }})
          </span>
        </v-btn>
      </v-col>
    </v-row>

    <custom-table
      ref="customTable"
      :key="`s_${status}`"
      :columns="columns"
      :custom-view="customView"
      :hiddenFilters="{ status, is_branch_delivery: 0 }"
      api-url="/order/v1/get-delivery-receipt-and-wait"
      download-file-name="danh-sach-don-hang.xlsx"
      table-height="calc(100vh - 195px)"
      @showDialogOrder="showDialogOrder"
    ></custom-table>

    <v-dialog v-model="orderDialog" max-width="480px">
      <DetailDialog
        v-if="orderDialog && order && order.id"
        :order="order"
        :key="detailKey"
        @close="hideDialogOrder"
        @onOrderChanged="onOrderChanged"
      />
    </v-dialog>
  </div>
</template>

<script>
import {
  CUSTOM_VIEW,
  DELIVERY_TYPES,
  ORDER_DELIVERY_STATUSES,
  // ORDER_CLASSIFIES,
} from "@/libs/const";
import { httpClient } from "@/libs/http";

export default {
  name: "DeliveryWaiting",
  components: {
    DetailDialog: () => import("@/components/exchange/DetailDialog"),
  },
  data: () => ({
    columns: [],
    sums: [],
    customView: CUSTOM_VIEW.DELIVERY_WAIT_LIST,
    deliveryStatusOptions: [...ORDER_DELIVERY_STATUSES],
    orderDialog: false,
    status: 1,
    detailKey: null,
  }),
  created() {
    const columns = [
      {
        type: "date-range-filter",
        label: this.$t("Thời gian"),
        placeholder: this.$t("Thời gian"),
        name: "created_at",
        hasSort: false,
        sortName: "created_at",
        key: "created_at",
        required: true,
      },
      {
        type: "input-filter",
        label: this.$t("Tracking"),
        placeholder: this.$t("Tracking"),
        name: "tracking_id",
        hasSort: false,
        sortName: "tracking_id",
        key: "tracking_id",
        required: true,
        action: "showDialogOrder",
      },
      {
        type: "select-filter",
        label: this.$t("Phân loại"),
        placeholder: this.$t("Phân loại"),
        name: "type",
        hasSort: false,
        sortName: "type",
        key: "type",
        options: [...DELIVERY_TYPES],
        required: true,
      },
      /* {
        type: "select-filter",
        label: this.$t("Trạng thái"),
        placeholder: this.$t("Trạng thái"),
        name: "status",
        hasSort: false,
        sortName: "status",
        key: "status",
        options: [...ORDER_DELIVERY_STATUSES],
        required: true,
      }, */
      {
        type: "select-branch",
        label: this.$t("Cơ sở"),
        placeholder: this.$t("Cơ sở"),
        name: "id_branch",
        hasSort: false,
        sortName: "id_branch",
        key: "branch_code",
        options: [],
        required: true,
      },
      {
        type: "input-filter",
        label: this.$t("Điểm xử lý"),
        placeholder: this.$t("Điểm xử lý"),
        name: "destination",
        hasSort: false,
        sortName: "destination",
        key: "destination",
        options: [],
        required: true,
        customValueClass: "text-capitalize",
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Khoảng cách"),
        placeholder: this.$t("Khoảng cách"),
        name: "distance",
        hasSort: false,
        sortName: "distance",
        key: "distance",
        required: true,
      },
      {
        type: "input-filter",
        label: this.$t("NV. Xử lý"),
        placeholder: this.$t("NV. Xử lý"),
        name: "account_name",
        hasSort: false,
        sortName: "account_name",
        key: "account_name",
        required: true,
      },
      {
        type: "date-range-filter",
        label: this.$t("Y.C xử lý"),
        placeholder: this.$t("Y.C xử lý"),
        name: "assigned_at",
        hasSort: false,
        sortName: "assigned_at",
        key: "assigned_at",
        required: true,
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Chờ"),
        placeholder: this.$t("Chờ"),
        name: "wait_seconds",
        hasSort: false,
        sortName: "wait_seconds",
        key: "wait_seconds",
        required: true,
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Xử lý"),
        placeholder: this.$t("Xử lý"),
        name: "process_seconds",
        hasSort: false,
        sortName: "process_seconds",
        key: "process_seconds",
        required: true,
      },
      {
        type: "date-range-filter",
        label: this.$t("Hoàn thành"),
        placeholder: this.$t("Hoàn thành"),
        name: "end_time",
        hasSort: false,
        sortName: "end_time",
        key: "end_time",
        required: true,
      },
    ];
    this.columns = [...columns];
  },
  mounted() {
    this.getDeliveryCount();
  },
  methods: {
    async getDeliveryCount() {
      const { data } = await httpClient.post("/order/v1/get-delivery-count");
      const deliveryStatusOptions = [...this.deliveryStatusOptions];
      for (let i = 0; i < deliveryStatusOptions.length; i++) {
        const deliveryStatus = deliveryStatusOptions[i];
        const item = [...data].find(
          (val) => val.status == deliveryStatus.value
        );
        if (item && item.count > 0) {
          deliveryStatusOptions[i].count = item.count;
        }
      }
      this.deliveryStatusOptions = [...deliveryStatusOptions];
    },
    changeStatus(status) {
      this.status = status;
    },

    onOrderChanged() {
      this.showDialogOrder({ id_order: this.order.id });
      this.refreshCustomTable();
    },

    refreshCustomTable() {
      this.$refs.customTable.getList();
    },

    async showDialogOrder(req) {
      const { data } = await httpClient.post("/order/v1/get-detail", {
        id_order: req.id_order,
      });
      this.order = { ...data };
      this.detailKey = this.generateRandomString(7);
      this.orderDialog = true;
    },

    hideDialogOrder() {
      this.order = {};
      this.detailKey = null;
      this.orderDialog = false;
    },
  },
};
</script>
